import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { HeaderRowCell } from './HeaderRowCell';
import { DESTINATION_TABLE_COLUMN, DestinationTableHeader } from 'modules/dataSync/types';
import { DESTINATION_COLUMN_GRID, HeaderGridRow } from './HeaderRow.styles';

type HeaderRowProps = {
  sortedBy: DESTINATION_TABLE_COLUMN;
  setSortedBy: (sortBy: DESTINATION_TABLE_COLUMN) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  columns: DestinationTableHeader[];
};

export const HeaderRow = ({
  sortedBy,
  setSortedBy,
  sortDirection,
  setSortDirection,
  columns,
}: HeaderRowProps) => {
  return (
    <HeaderGridRow gridLayout={DESTINATION_COLUMN_GRID}>
      {columns.map((column) => (
        <HeaderRowCell
          column={column}
          columnId={column.id}
          key={column.id}
          isActiveSortColumn={column.id === sortedBy}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
        />
      ))}
    </HeaderGridRow>
  );
};
